export var InventoryLogType;
(function (InventoryLogType) {
    InventoryLogType[InventoryLogType["ADD"] = 1] = "ADD";
    InventoryLogType[InventoryLogType["CYCLE_COUNT"] = 2] = "CYCLE_COUNT";
    InventoryLogType[InventoryLogType["MOVE"] = 3] = "MOVE";
    InventoryLogType[InventoryLogType["SCRAP"] = 4] = "SCRAP";
    InventoryLogType[InventoryLogType["SHIP"] = 5] = "SHIP";
    InventoryLogType[InventoryLogType["RECEIVE"] = 6] = "RECEIVE";
    InventoryLogType[InventoryLogType["COMMIT"] = 7] = "COMMIT";
    InventoryLogType[InventoryLogType["UNCOMMIT"] = 8] = "UNCOMMIT";
    InventoryLogType[InventoryLogType["BUILD"] = 9] = "BUILD";
    InventoryLogType[InventoryLogType["COST_ADJUST"] = 10] = "COST_ADJUST";
    InventoryLogType[InventoryLogType["INITIAL"] = 11] = "INITIAL";
})(InventoryLogType || (InventoryLogType = {}));
//# sourceMappingURL=inventory-log-type.js.map